import {makeAutoObservable} from 'mobx';
import GradebookRepository from '../../../../../data/repositories/GradebookRepository';
import {toast} from 'react-toastify';
import {getErrorFromCode} from '../../../../../data/errorCodes';
import {toastConfig} from '../../../../../uiToolkit/Toast/toastConfig';
import LoadingModule from '../../../../../modules/LoadingModule/LoadingModule';

class CourseAnalyticsOverviewStore {
  private gradebookRepo = new GradebookRepository();
  private loadingModule = new LoadingModule();

  constructor() {
    makeAutoObservable(this);
  }

  public get isLoading() {
    return this.loadingModule.isLoading;
  }

  public async fetchCourseGradebook(organizationId: string, courseId: string) {
    const result = await this.gradebookRepo.getCourseGradebook(
      organizationId,
      courseId,
    );

    if (result.success && result.data) {
      return result.data;
    }

    if (result.errors && result.errors.length) {
      toast.error(getErrorFromCode(result.errors[0]), toastConfig);
    }
  }
}

export default CourseAnalyticsOverviewStore;
